import React from 'react';
import { CookieAlert } from 'components';
import { render } from 'react-dom';

export default element => {
    render(<CookieAlert />, element);
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/alerts/cookies/index.js